module.exports = __webpack_public_path__ + "static/media/devsetup.a2cac37e.jpg";